import React from 'react';
import { string, number } from 'prop-types';
import styled from 'styled-components';

import Box from '../atoms/Box';
import Text from '../atoms/Text';

const StyledNumber = styled('div')(({ theme }) => ({
  color: theme.colors.greyLight,
  fontSize: '100px',
  position: 'absolute',
  left: 0,
  right: 0,
  zIndex: -1,
  opacity: 0.4,
  top: theme.space[4],
  margin: 'auto',
  fontWeight: 900
}));

const BulletParagraph = ({ title, desc, number }) => {
  return (
    <Box position="relative" zIndex="1" pt={5}>
      <StyledNumber>{number}</StyledNumber>
      <Text styleName="wH3" mb={4}>
        {title}
      </Text>
      <Text>{desc}</Text>
    </Box>
  );
};

BulletParagraph.propTypes = {
  title: string,
  desc: string,
  number: number
};

BulletParagraph.defaultProps = {
  title: '',
  desc: '',
  number: 0
};

export default BulletParagraph;
